import moment from 'moment';
import {store} from '../store/store';

const LOCALE = {
    en_US: 'en',
    fr_FR: 'fr',
};

export default function (date) {
    if (!date) {
        return null;
    }
    moment.locale(LOCALE[store.getters['user/auth/locale']]);
    return moment(date).format('L');
}



// WEBPACK FOOTER //
// ./src/filters/formatDate.js